/*
 * Copyright (c) 2018. Rezo Zero
 *
 * This file is part of Supreme NTM.
 *
 * Supreme NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file VideosBlock.js
 * @author Ambroise Maupate <ambroise@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {AbstractBlock} from 'starting-blocks'
import $ from 'jquery'
import * as log from 'loglevel'

export default class VideosBlock extends AbstractBlock {
    init () {
        super.init()
        log.debug('\t📺 Videos listing')

        if (!window.fetch) {
            throw new Error('window.fetch is not supported by your browser.')
        }

        this.options = {
            playlistId: window.TEMP.youtubePlaylistId,
            part: 'snippet,contentDetails',
            key: window.TEMP.googleApiKey
        }
        this.endPoint = 'https://www.googleapis.com/youtube/v3/playlistItems?' + $.param(this.options)
        this.fetchApi().then(data => {
            const jsonData = JSON.parse(data)
            this.render(jsonData.items)
        })
    }

    fetchApi () {
        return new Promise((resolve, reject) => {
            window.fetch(this.endPoint, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Referer': window.location.origin,
                    'credentials': 'same-origin'
                },
                cache: 'default'
            }).then(res => {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.text())
                }
                const err = new Error(res.statusText || res.status)
                reject(err)
            }).catch(err => {
                reject(err)
            })
        })
    }

    render (contents) {
        for (const video of contents) {
            const date = new Date(video.snippet.publishedAt)
            const monthOptions = { month: 'long', day: 'numeric' }
            const yearOptions = { year: 'numeric' }
            const template = `
<div class="video" id="video-${video.contentDetails.videoId}" data-youtube-id="${video.contentDetails.videoId}">
    <div class="video-details">
        <iframe width="${video.snippet.thumbnails.maxres.width}"
                height="${video.snippet.thumbnails.maxres.height}"
                frameborder="0"
                allow="autoplay; encrypted-media" 
                allowfullscreen
                src="https://www.youtube.com/embed/${video.contentDetails.videoId}?rel=0&showinfo=0"></iframe>
        <img src="${video.snippet.thumbnails.maxres.url}" 
             width="${video.snippet.thumbnails.maxres.width}" 
             height="${video.snippet.thumbnails.maxres.height}" 
             class="img-fluid"
             alt="${video.snippet.title}">
    </div>
    <p class="video-title">${video.snippet.title}</p>
    <time class="video-date date" 
          datetime="${video.snippet.publishedAt}">${date.toLocaleDateString('fr', monthOptions)} <span class="year">${date.toLocaleDateString('fr', yearOptions)}</span></time>
</div>`

            this.$cont.append(template)
        }
    }
}



// WEBPACK FOOTER //
// ./webpack/js/blocks/VideosBlock.js